"use-strict";
/* global $ */



import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
window.$ = window.jQuery = require('jquery');
import Barba from 'barba.js';
// var imagesLoaded = require('imagesloaded');
// imagesLoaded.makeJQueryPlugin($);
// require("select2-full");
import Swiper from 'swiper/swiper-bundle.js';
import interact from 'interactjs';
// import 'fullpage.js/vendors/easings.min.js';
// require('fullpage.js/vendors/scrolloverflow.min.js');
// import fullpage from 'fullpage.js'; 
// import ScrollMagic from 'ScrollMagic';
// import 'animation.gsap';
// import 'debug.addIndicators';
// import EasyPZ from 'easypz';
// import noUiSlider from 'nouislider';
// require('malihu-custom-scrollbar-plugin-concat');
// require('jquery-background-video/bgvideo.js');
require('waypoints/lib/noframework.waypoints.min');
// import panzoom from 'panzoom';
// import Plyr from 'plyr';
// import hoverintent from 'hoverintent';
import dayjs from 'dayjs';
import 'parsleyjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import "CookieConsent"
import anime from 'animejs';
import objectFitImages from 'object-fit-images';

var Common = {
    lastScrollPos: 0,
    $container: null,
    menuSliders: [],
    popupInstances: [],
    sidebarInstances: [],
    menuStatus: null,
    sectionSlider: null,
    resize: null,
    originIndex: 0,
    newIndex: 0,
    script: null,
    init: function(){
        history.scrollRestoration = "manual";
        Common.detectDevice();
        Common.initBarba();
        Common.detectIE();
        if($('html').hasClass('ie')){
            window.lazySizesConfig = window.lazySizesConfig || {};
            lazySizesConfig.preloadAfterLoad = true;
        }

        objectFitImages(null, {watchMQ:true});

        $(document).on('click', '#landing-disclaimer .close', function(){
            if(!$('html').hasClass('agreed-disclaimer')){
                $('#landing-disclaimer').addClass('closing');
                $('html').addClass('agreed-disclaimer');
                $(document).trigger('agreeddisclaimer');
                $(window).trigger('resize');
                setTimeout(function(){
                    $('#landing-disclaimer').addClass('closed');
                }, 1000);
                
            }
        });

        // $('.cookies-statement .close').on('click', function(){
        //     $('.cookies-statement').fadeOut();
        // });

        window.cookieconsent.initialise({
          "palette": {
            "popup": {
              "background": "#000"
            },
            "button": {
              "background": "#f1d600"
            }
          },
          "position" : "bottom",
          "theme": "classic",
          "content": {
            "message": 'This website uses cookies to ensure you get the best experience on our website.',
            "link": 'More Info',
            "href": privacyPageUrl,
            "dismiss": "<svg height='329pt' viewBox='0 0 329.26933 329' width='329pt' xmlns='http://www.w3.org/2000/svg' fill='#ffffff'><path d='m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0'/></svg>",
          },
          "elements": {
            "messagelink": '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}">{{link}}</a></span>',
          }
        });
    },
    initBarba: function(){
        Barba.Pjax.Dom.containerClass = "transition-container";
        Barba.Pjax.Dom.wrapperId = "transition-wrapper";
        Barba.Pjax.Dom.dataNamespace = "template";
        Barba.Utils.xhrTimeout = 10000;
        Barba.Pjax.cacheEnabled = false;
        Barba.Dispatcher.on('newPageReady', function(current, prev, container) {
            Common.$container = $(container);
            window.scrollTo(0, 0);
            // Common.layout(Common.$container);
            fbq('track', 'PageView');

            // events
            Common.$container.find('.main-menu .nav-category-button>button').on("click touch", function() {
                var target = $(this).data('id');
                Common.$container.find('#menu').addClass('show-sub');
                Common.$container.find('.sub-menu-item').removeClass('active');
                Common.$container.find('.sub-menu-item[data-id="'+target+'"]').addClass('active');
            });
            Common.$container.find('.sub-menu button.back').on("click touch", function() {
                var target = $(this).data('id');
                Common.$container.find('#menu').removeClass('show-sub');
                Common.$container.find('.sub-menu-item').removeClass('active');
            });

            Common.$container.find('.scroll-indicator.down').on("click touch", function() {
                Common.sectionSlider.slideNext();
            });
            Common.$container.find('.scroll-indicator.up').on("click touch", function() {
                Common.sectionSlider.slidePrev();
            });

            Common.$container.find('.disclaimer-open').on("click touch", function() {
                $(this).toggleClass('active');
            });

            Common.$container.find('.contact-box .open').on("click", function() {
                $(this).closest('.contact-box').toggleClass('active');
            });

            Common.$container.find('.contact-box').on("mouseenter", function() {
                $(this).addClass('active');
            });

            Common.$container.find('.contact-box').on("mouseleave", function() {
                $(this).removeClass('active');
            });
            // $(document).one('scroll', function(){
            //     anime({
            //         targets: $('#header>.logo')[0],
            //         opacity: 0,
            //         duration: 300,
            //         easing: 'easeOutCubic',
            //         complete: function(){
            //             $('#header>.logo').hide();
            //         }
            //     });
            // });

            // $('#header .overlay').on('click', Common.closeMenu);

            // Common.arrowAnimation();
            // Common.$container.find('.scroll-indicator.down').on("click touch", function() {
            //     Common.sectionSlider.slideNext();
            // });
            // Common.$container.find('.scroll-indicator.up').on("click touch", function() {
            //     Common.sectionSlider.slidePrev();
            // });

            // Common.$container.find('.open-popup').on('click', function(e){
            //     var $content = $(e.currentTarget).find('.scrollable-popup-content');
            //     var popup = new ScrollablePopup();
            //     popup.open($content);
            //     if(typeof fullpage_api !== "undefined"){
            //         fullpage_api.destroy();
            //     }
            //     // fullpage_api.setAutoScrolling(false);
            //     $(document).scrollTop(0);

            //     // popup.once('close', function(){
            //     //     if(!Common.$container.hasClass('detail')){
            //     //         Common.initFullpage(Common.$container, '', true);
            //     //     }
            //     // });
            // });

            // Common.$container.find('.font-size-selector button').on("click touch", function() {
            //     var size = $(this).data('size');
            //     $('html').removeClass('font-small').removeClass('font-medium').removeClass('font-large').addClass(size);
            //     $('html').data('font-size', size);
            //     Common.$container.find('.font-size-selector button').removeClass('active');
            //     Common.$container.find('.font-size-selector button[data-size='+size+']').addClass('active');
            // });

            // Common.$container.find('.font-size-selector button').each(function() {
            //     if($('html').hasClass('landing')) return false;
            //     var size = $('html').data('font-size');
            //     if($(this).data('size') == size){
            //         $(this).addClass('active');
            //     }else{
            //         $(this).removeClass('active');
            //     }
            // });
            $(window).on('resize orientationchange', function(){
                Common.fitMain();
            }).trigger('resize');

            Common.$container.find('.ps-image').on("click touch", Common.imagesZoom);

            Common.$container.find('.open-document').on('click', function(){
                var target = $(this).data('id');
                $('.document-item').removeClass('active');
                $('.document-item[data-id="'+target+'"]').addClass('active');
                if(window.matchMedia('(max-width: 767px)').matches){
                    Common.$container.find('#menu-wrapper input').prop("checked", false);
                }
            });

            $('.document-item .close').on('click', function(){
                $('.document-item').removeClass('active');
            });
        });
        Barba.Pjax.getTransition = function() {
            return Common.pageTransition;
        };
    },
    pageTransition: Barba.BaseTransition.extend({
        start: function() {
            Promise
                .all([this.newContainerLoading, this.fadeOut()])
                // .then(this.fadeOut.bind(this))
                .then(this.fadeIn.bind(this));
        },
        fadeOut: function() {
            var deferred = Barba.Utils.deferred();

            $("html").removeClass("landing no-js");

            $("#transition-animation").css({
                'pointer-events': 'all',
                opacity: 1
            });

            Common.popupInstances.forEach(function(item){
                item.close();
            });

            setTimeout(function(){

                deferred.resolve();
            }, 500);
            // anime({
            //     targets: $("#transition-animation")[0],
            //     opacity: 1,
            //     easing: 'easeOutCubic',
            //     duration: 300,
            //     complete: function(){
            //         deferred.resolve();
                    
            //     }
            // });
            return deferred.promise;
        },
        fadeIn: function() {
            // window.scrollTo(0, 0);
            var _this = this;
            var $container = $(this.newContainer);
            $container.scrollTop(0);
        
            // anime({
            //  targets: this.newContainer,
            //  opacity: 1,
            //  easing: 'easeOutCubic',
            //  duration: 500
            // });
            _this.done();
            
        }
    }),
    pageTransitionLeave: function(){

    },
    pageTransitionEnter: function($container){
        return new Promise(function(resolve){
            // $("#transition-animation .layer-1").show();
            // $("#transition-animation .opening").hide();
            Common.$container.show();
            resolve();
            $("#transition-animation").css({
                opacity: 0
            });

            setTimeout(function(){
                $("#transition-animation").css({
                    'pointer-events': 'none',
                });
                resolve();

            }, 500);
            // anime({
            //     targets: $("#transition-animation")[0],
            //     opacity: 0,
            //     easing: 'easeOutCubic',
            //     duration: 300,
            //     begin: function(){
            //         Common.$container.show();
            //         resolve();
            //     },
            //     complete: function(){
                    
            //     }
            // });
        });
    },
    fitMain: function($container){
        var windowHeight = $(window).height();
        var headerHeight = Common.$container.find('#header').outerHeight();
        var footerHeight = Common.$container.find('#footer').outerHeight();
        var $main = Common.$container.find('main');

        if($main.hasClass('show-header') && $main.hasClass('show-footer')){
            var height = windowHeight - headerHeight - footerHeight;
            $main.height(height);
            $main.css({
                "min-height": height
            });
            if($main.hasClass('home') && window.matchMedia('(max-width: 768px) and (orientation: portrait)').matches){
                var height = windowHeight - headerHeight - Common.$container.find('#footer .spl-logo').outerHeight();
                $main.height(height);
                $main.css({
                    "min-height": height
                });
            }
        }else if($main.hasClass('show-header') && $main.hasClass('fullpage')){
            var height = windowHeight - headerHeight;
            var targetHeight = $main.data('target') ? Common.$container.find($main.data('target')).outerHeight() : 0;
            height = targetHeight > height ? targetHeight : height;
            $main.css({
                "min-height": height
            });
        }else if($main.hasClass('show-header')){
            var height = windowHeight - headerHeight;
            var targetHeight = $main.data('target') ? Common.$container.find($main.data('target')).outerHeight() : 0;
            height = targetHeight > height ? targetHeight : height;
            $main.height(height);
            $main.css({
                "min-height": height
            });
        }else if($main.hasClass('slideshow')){
            var height = windowHeight;
            $main.outerHeight(height);
            $main.css({
                "min-height": height
            });
        }else if($main.hasClass('fullpage')){
            var height = windowHeight - headerHeight - footerHeight;
            $main.css({
                "min-height": height
            });
        }
        
    },
    fitMainFull: function(){
        var windowHeight = $(window).height();

        Common.$container.find('main').height(windowHeight);
        
    },
    fitMainNoFoot: function(){
        var windowHeight = $(window).height();
        var headerHeight = Common.$container.find('#header').outerHeight();

        Common.$container.find('#main').height(windowHeight - headerHeight);
        
    },
    loadScript: function (src, async, defer) {
        return new Promise(function (resolve, reject) { 
            if($('script[src="'+ src +'"]').length > 0){
                resolve();
            }else{
                var s;
                Common.script = document.createElement('script');
                Common.script.src = src;
                Common.script.onload = resolve;
                Common.script.onerror = reject;
                if(async) Common.script.async = true;
                if(defer) Common.script.defer = true;
                document.head.appendChild(Common.script);
            }
        });
    },
    detectDevice: function(){
        // $(window).on('mouseover', function onFirstHover() {
        //     $('html').addClass('desktop').removeClass('mobile');
        //     $(window).off('mouseover', onFirstHover, false);
        // });
        if(!('ontouchstart' in window)){
            $('html').addClass('desktop').removeClass('mobile');
        }
    },
    detectIE: function() {
        var isIE = false;
        var ua = window.navigator.userAgent;

        if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) isIE = true;

        if(isIE) $('html').addClass('ie');

    },
    isMobile: function(){
        // return window.matchMedia('(max-width: 768px) and (orientation: portrait)').matches || window.matchMedia('(max-width: 1024px) and (orientation: landscape)').matches;
        if(!('ontouchstart' in window)){
            return false;
        }
        return true;
    },
    menuShrink: function(){
        // if(window.matchMedia('(max-width: 767px)').matches){
        //  if($(window).scrollTop() > 50 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //  }else if($(window).scrollTop() <= 50 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //  }
        //  TweenLite.set('#header-body-center .logo-complete', {display: 'none'});
        //  TweenLite.set('#header-body-center .logo-simple', {display: 'block', autoAlpha: 1});
        // }else if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
        //  if($(window).scrollTop() > 60 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //  }else if($(window).scrollTop() <= 60 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //  }
        //  TweenLite.set('#header-body-center .logo-complete', {display: 'none'});
        //  TweenLite.set('#header-body-center .logo-simple', {display: 'block', autoAlpha: 1});
        // }else{
        //  if($(window).scrollTop() > 200 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //      var expand = new TimelineMax();
        //      expand.to('#header-body-center .logo', 0.3, {'width': 179, height:32, ease:Power3.easeOut}, 0);
        //  }else if($(window).scrollTop() <= 200 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //      var shrink = new TimelineMax();
        //      shrink.to('#header-body-center .logo', 0.3, {'width': 256, height:102, ease:Power3.easeOut}, 0);
        //  }
        // }
        
    },
    
    beautifyScrollbar: function(){
        // var $dropdown = $('.select2-dropdown .select2-results__options');
        // var $container = $dropdown.parents('.select2-dropdown');
        // TweenLite.set($container, {autoAlpha: 0});
        // if($dropdown.length > 1){
        //  $dropdown.last().mCustomScrollbar('destroy');
        // }else $dropdown.mCustomScrollbar('destroy');
        // setTimeout(function() {
        //  $dropdown.mCustomScrollbar({
        //      advanced:{
        //          updateOnContentResize: true
        //      },
        //      theme:"dark-2",
        //      scrollInertia: 200
        //  });
            
        //  TweenLite.to($container, 0.3, {autoAlpha: 1, ease: Power4.easeout});
        // }, 0);
    },
    throttle: function(a,b){var c,d;return function(){var e=this,f=arguments,g=+new Date;c&&g<c+a?(clearTimeout(d),d=setTimeout(function(){c=g,b.apply(e,f)},a)):(c=g,b.apply(e,f))}},
    debounce: function(a,b,c){var d,e;return function(){function h(){d=null,c||(e=a.apply(f,g))}var f=this,g=arguments;return clearTimeout(d),d=setTimeout(h,b),c&&!d&&(e=a.apply(f,g)),e}},

    imagesZoom: function(e){
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $wrapper = $this.closest('.ps-wrapper').length ? $this.closest('.ps-wrapper') : $this.closest('.section');
        var $image = $wrapper.find('.ps-image:visible, .desktop-hide .ps-image, .mobile-hide .ps-image');
        var index = $wrapper.find('.ps-image:visible, .desktop-hide .ps-image, .mobile-hide .ps-image').index($this);
        var items = [];
        $image.each(function(){
            const src = $(this).data("ps-src") || $(this).attr("src");
            const w = $(this).data("ps-w") || this.naturalWidth;
            const h = $(this).data("ps-h") || this.naturalHeight;
            var caption = $(this).data("ps-caption") || '';
            caption = caption.split(' - ');
            if(caption.length === 2){
                caption = caption[0] + '<br>' + caption[1];
            }else{
                caption = caption[0];
            }
            items.push({
                src: src,
                w: w,
                h: h,
                msrc: src,
                title: caption
            });
        });
        var $pswp = $('.pswp')[0];
        var options = {
                index: index,
                bgOpacity: 0.95,
                // showHideOpacity: true,
                // showAnimationDuration: 2000,
                history: false,
                // fullscreenEl: true,
                shareEl: false,
                // counterEl: false,
                // closeOnScroll: false,
                scaleMode: 'fit',
                // getThumbBoundsFn: function(i) {
                //     var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                //     var rect = $image[i].getBoundingClientRect();
                //     return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                // }
        }
        var ps = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        ps.init();
    },
    mobileShare: function(e){
        e.preventDefault();
        var url = document.location.href;
        if (navigator.share) {
          navigator.share({
              url: url
          });
        }
    },
    video2Cover: function($container, alignment){
        var $videos = $container.find('video.cover-video');
        $videos.each(function(){
            var $this = $(this);
            var parentWidth = $this.parent().outerWidth();
            var parentHeight = $this.parent().outerHeight();
            var aspectRatio = $this.data('ratio');
            var newHeight, newWidth, halfWidth, halfHeight;
            if(alignment === 'bottom'){
                if(parentWidth / parentHeight > aspectRatio){
                    if(newWidth > parentWidth){
                        newWidth = parentHeight*aspectRatio;
                        newHeight = newWidth/aspectRatio;
                        halfWidth = newWidth/2;
                        $this.css({
                            "height": newHeight,
                            "width":newWidth,
                            "left":"50%",
                            "bottom":"auto",
                            "top":"auto",
                            "transform": "translate(-"+halfWidth+"px, 0)"
                        });
                    }else{
                        newHeight = parentWidth/aspectRatio;
                        newWidth = newHeight*aspectRatio;
                        halfHeight = newHeight/2;
                        $this.css({
                            "height":newHeight,
                            "width": newWidth,
                            "left": 0,
                            "bottom":0,
                            "top":"auto",
                            "transform": ""
                        });
                    }
                }else{
                    newHeight = parentHeight;
                    newWidth = newHeight*aspectRatio;
                    halfWidth = newWidth/2;
                    $this.css({
                        "height":newHeight,
                        "width":newWidth,
                        "left":"50%",
                        "bottom": 0,
                        "top":"auto",
                        "transform": "translate(-"+halfWidth+"px, 0)"
                    });
                }
            }else{
                if(parentWidth / parentHeight > aspectRatio){
                    if(newWidth > parentWidth){
                        newWidth = parentHeight*aspectRatio;
                        newHeight = newWidth/aspectRatio;
                        halfWidth = newWidth/2;
                        $this.css({
                            "height": newHeight,
                            "width":newWidth,
                            "left":"50%",
                            "top":"auto",
                            "transform": "translate(-"+halfWidth+"px, 0)"
                        });
                    }else{
                        newHeight = parentWidth/aspectRatio;
                        newWidth = newHeight*aspectRatio;
                        halfHeight = newHeight/2;
                        $this.css({
                            "height":newHeight,
                            "width": newWidth,
                            "left": 0,
                            "top":"50%",
                            "transform": "translate(0, -"+halfHeight+"px)"
                        });
                    }
                }else{
                    newHeight = parentHeight;
                    newWidth = newHeight*aspectRatio;
                    halfWidth = newWidth/2;
                    $this.css({
                        "height":newHeight,
                        "width":newWidth,
                        "left":"50%",
                        "top": 0,
                        "transform": "translateX(-"+halfWidth+"px)"
                    });
                }
            }
            
                
        });
    }
    
}


var Home = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'home',
        onEnter: function() {
            Home.$container = $(this.container);


            var $content = $('.scrollable-popup-content.popup-banner');
            if($('html').hasClass("landing") && $content.length){
                ;
                var html = $content.find("h3").html();
                html = html.replace("#", "<sup>#</sup>");
                $content.find("h3").html(html);
                var popup = new ScrollablePopup();
                popup.open($content);
            }
            
            
            if($('html').hasClass('agreed-disclaimer')){
                if(Home.$container.find('.home-video').length) Home.$container.find('.home-video')[0].play();
            }else{
                $(document).on('agreeddisclaimer', function(){
                    if(Home.$container.find('.home-video').length) Home.$container.find('.home-video')[0].play();
                })
            }

            // events
            new Swiper ( Home.$container.find('.swiper-container')[0], {
                slidesPerView: 1,
                speed: 1500,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                      el:  Home.$container.find('.swiper-pagination')[0],
                      clickable: true
                },
                
            });

            $(window).on('resize orientastionchange', function(){
                
                // var portraitVideoSrc = Home.$container.find('.video-bkg').data('src-portrait');
                // var landscapeVideoSrc = Home.$container.find('.video-bkg').data('src-landscape');
                // var src = window.matchMedia('(orientation: portrait)').matches ? portraitVideoSrc : landscapeVideoSrc;
                // var ratio = window.matchMedia('(orientation: portrait)').matches ? 0.5625 : 1.77777777778;
                // Home.$container.find('.video-bkg video source').attr('src', src);
                // Home.$container.find('.video-bkg video').data('ratio', ratio);
                Common.video2Cover(Home.$container, 'top');
                // Home.$container.find('.video-bkg video')[0].load();
                // Home.$container.find('.video-bkg video')[0].play();
            })

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Home.$container).then(function(){

                Common.video2Cover(Home.$container);

                
            });
        },
        onLeave: function() {
            
        },
        onLeaveCompleted: function() {

        }
    }),
    resize: function(){

    }
}



var Location = {
    $container: null,
    map: null,
    point: null,
    point2: null,
    google_map: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-location',
        onEnter: function() {
            Location.$container = $(this.container);

            $(window).on('resize.location orientationchange.location', function(){
                var portraitVideoSrc = Location.$container.find('.video-bkg').data('src-portrait');
                var landscapeVideoSrc = Location.$container.find('.video-bkg').data('src-landscape');
                var src = window.matchMedia('(orientation: portrait)').matches ? portraitVideoSrc : landscapeVideoSrc;
                var ratio = window.matchMedia('(orientation: portrait)').matches ? 0.5625 : 1.77777777778;
                Location.$container.find('.video-bkg video source').attr('src', src);
                Location.$container.find('.video-bkg video').data('ratio', ratio);
                Common.video2Cover(Location.$container);
                Location.$container.find('.video-bkg video')[0].load();
                Location.$container.find('.video-bkg video')[0].play();
            });
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Location.$container).then(function(){
                var option = {
                    direction: 'vertical',
                    speed: 1000,
                    mousewheel: {},
                    slidesPerView: 'auto',
                    scrollbar: {
                        el: Location.$container.find('.swiper-scrollbar')[0],
                        draggable: true,
                    },
                    on: {
                        slideChange: function(){
                            var oldIndex = this.previousIndex;
                            var newIndex = this.activeIndex;

                            if($(this.slides[newIndex]).find('.video-bkg video').length){
                                var video = $(this.slides[newIndex]).find('.video-bkg video')[0];
                                
                                setTimeout(function(){
                                    video.play();
                                }, 800);
                                
                            }
                        },
                        slideChangeTransitionEnd: function(){
                            var newIndex = this.activeIndex;
                            if(!$(this.slides[newIndex]).find('.video-bkg video').length){
                                var video = Location.$container.find('.video-bkg video')[0];
                                video.currentTime = 0;
                                Location.$container.find('.video-bkg video')[0].pause();
                            }
                            
                        }
                    }
                }
                
                Common.sectionSlider = new Swiper (Location.$container.find('.section-wrapper.swiper-container')[0], option);

            });
        },
        onLeave: function() {
            $(window).off('resize.location orientationchange.location');
            
        },
        onLeaveCompleted: function() {
        }
    })
    
}

    

var Living = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-living',
        onEnter: function() {
            Living.$container = $(this.container);

            
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Living.$container).then(function(){
                Living.$container.find('.section-wrapper.swiper-container').each(function(i){

                    var option = {
                        direction: 'vertical',
                        speed: 1000,
                        mousewheel: {},
                        slidesPerView: 'auto',
                        scrollbar: {
                            el:  Living.$container.find('.swiper-scrollbar')[0],
                            draggable: true,
                        },
                        on: {
                            slideChange: function(){
                                var newIndex = this.activeIndex;
                                $(this.slides[newIndex]).addClass('viewed');
                            }
                        }
                    }
                    
                    Common.sectionSlider = new Swiper (this, option);
                });
            });
        },
        onLeave: function() {
            Common.sectionSlider = null;
        },
        onLeaveCompleted: function() {
        }
    })
}

var Design = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-design',
        onEnter: function() {
            Design.$container = $(this.container);

            $(window).on('resize.design orientationchange.design', function(){

                var ratio = 0.8113207547;
                var containerHeight = Design.$container.find('.section.tower .bkgpic').height();
                var containerWidth = Design.$container.find('.section.tower .bkgpic').width();
                var towerHeight = Design.$container.find('.tower-wrapper').height();
                var towerWidth = Design.$container.find('.tower-wrapper').width();
                if(containerWidth / containerHeight > ratio){
                    Design.$container.find('.tower-wrapper').height(containerHeight);
                    Design.$container.find('.tower-wrapper').width(containerHeight * ratio);
                }else{
                    Design.$container.find('.tower-wrapper').width(containerWidth);
                    Design.$container.find('.tower-wrapper').height(containerWidth / ratio);
                }


            }).trigger('resize');
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Design.$container).then(function(){
                Design.$container.find('.section-wrapper.swiper-container').each(function(i){

                    // if(window.matchMedia('(max-width: 1024px)').matches){
                    //     Design.$container.find('.section.tower').addClass('swiper-no-swiping');
                    // }
                    

                    var option = {
                        direction: 'vertical',
                        speed: 1000,
                        mousewheel: {},
                        slidesPerView: 'auto',
                        scrollbar: {
                            el: Design.$container.find('.swiper-scrollbar')[0],
                            draggable: true,
                        },
                        // on: {
                        //     slideChange: function(){
                        //         var newIndex = this.activeIndex;

                        //         if(newIndex === 1) {
                        //             Design.$container.find('.contact-box').addClass('active');
                        //         }else{
                        //             Design.$container.find('.contact-box').removeClass('active');
                        //         }
                        //     },
                        //     // slideChangeTransitionEnd: function(){
                        //     //     var newIndex = this.activeIndex;

                        //     //     if(newIndex !== 1) {
                        //     //         Design.$container.find('.contact-box').removeClass('active');
                        //     //     }
                        //     // }
                        // }
                    }
                    
                    Common.sectionSlider = new Swiper (this, option);
                });
            });
        },
        onLeave: function() {
            Common.sectionSlider = null;
            $(window).off('resize.design orientationchange.design');
        },
        onLeaveCompleted: function() {
        }
    })
}


var Terms = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-terms',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Terms.$container = $(this.container);
            Common.pageTransitionEnter(Terms.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Documents = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-documents',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Documents.$container = $(this.container);
            Common.pageTransitionEnter(Documents.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Member = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-login',
        onEnter: function() {
            Member.$container = $(this.container);

            if(window.location.href.indexOf("success") > -1){
                $('#landing-disclaimer').addClass('closed');
            }

            Member.$container.find('input').on('focus', function(){
                $(this).closest('.input-wrapper').addClass('active');
            });

            Member.$container.find('input').on('blur', function(){
                $(this).closest('.input-wrapper').removeClass('active');
            });

            Member.$container.find('input,select').on('input change', function(){
                if($(this).val() !== ''){
                    $(this).closest('.input-wrapper').addClass('typed');
                }else{
                    $(this).closest('.input-wrapper').removeClass('typed');
                }
            });

            Member.$container.find('#login-form [type=submit]').on('click', function(e) {
                e.preventDefault();     
                var $form = $(this).closest('form');
                var validator = $form.parsley({
                    errorsContainer: function(el){
                        return $(el.$element).closest('.input-wrapper').find('.error-container');
                    }
                });
                var formValid = validator.validate();

                if(formValid){
                    $.ajax({
                        type: "POST",
                        url: '/wp-admin/admin-ajax.php',
                        dataType:"json",
                        data: $form.serialize(),
                        cache: false,
                        beforeSend: function(){
                            $form.find('button[type=submit]').addClass('loading').attr('disabled', 'disabled');
                        },
                        success: function(data){
                            if(data['success']){
                                // window.location.reload(false);
                                dataLayer.push({
                                    event: "login",
                                    userID: data['data']['uid']
                                });

                                Barba.Pjax.goTo(data['data']['url']);

                            }else if(!data['success']){
                                if(data['data'] == 'no user found'){
                                    $form.find('.response').text($form.find('.response').data('no-user'));
                                }else if(data['data'] == 'account not activated'){
                                    $form.find('.response').text($form.find('.response').data('activation'));
                                }else{
                                    $form.find('.response').text($form.find('.response').data('error'));
                                }
                            }

                            $form.find('button[type=submit]').removeClass('loading').removeAttr('disabled');
                        }
                    });
                }
                
            });

            Member.$container.find('#register-form [type=submit]').on('click', function(e) {
                e.preventDefault();
                var $form = $(this).closest('form');
                var validator = $form.parsley({
                    errorsContainer: function(el){
                        return $(el.$element).closest('.input-wrapper').find('.error-container');
                    }
                });
                var formValid = validator.validate();

                if(formValid){
                    $.ajax({
                        type: "POST",
                        url: '/wp-admin/admin-ajax.php',
                        dataType:"json",
                        data: Member.$container.find('#register-form').serialize(),
                        cache: false,
                        beforeSend: function(){
                            $form.find('button[type=submit]').addClass('loading').attr('disabled', 'disabled');
                            $form.find('.response').text('');
                        },
                        success: function(data){
                            if(data['success']){
                                

                                var userId = data['data']['uid'];
                                dataLayer.push({
                                    event: 'signup',
                                    userID: userId
                                });

                                var form = document.createElement("form");
                                form.method = "POST";
                                form.action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";

                                var elementOID = document.createElement("input");  
                                elementOID.name="oid";
                                elementOID.value='00D28000001A8GX';
                                elementOID.setAttribute("type", "hidden");
                                form.appendChild(elementOID);  

                                var elementRetURL = document.createElement("input"); 
                                elementRetURL.name="retURL";
                                elementRetURL.value=location.protocol+'//'+location.hostname + '/register/success/';
                                elementRetURL.setAttribute("type", "hidden");
                                form.appendChild(elementRetURL);

                                var elementSalutation = document.createElement("input"); 
                                elementSalutation.name="salutation";
                                elementSalutation.value=$form.find('select[name="salutation"] option:checked').val();
                                elementSalutation.setAttribute("type", "hidden");
                                form.appendChild(elementSalutation);  

                                var elementFirstName = document.createElement("input"); 
                                elementFirstName.name="first_name";
                                elementFirstName.value=$form.find('input[name="firstname"]').val();
                                elementFirstName.setAttribute("type", "hidden");
                                form.appendChild(elementFirstName);  

                                var elementLastName = document.createElement("input");  
                                elementLastName.name="last_name";
                                elementLastName.value=$form.find('input[name="lastname"]').val();
                                elementLastName.setAttribute("type", "hidden");
                                form.appendChild(elementLastName);

                                var elementEmail = document.createElement("input"); 
                                elementEmail.name="email";
                                elementEmail.value=$form.find('input[name="user_email"]').val();
                                elementEmail.setAttribute("type", "hidden");
                                form.appendChild(elementEmail);

                                var elementMobile = document.createElement("input"); 
                                elementMobile.name="mobile";
                                elementMobile.value=$form.find('input[name="phone"]').val();
                                elementMobile.setAttribute("type", "hidden");
                                form.appendChild(elementMobile);

                                var elementUserID = document.createElement("input"); 
                                elementUserID.name="00N0K00000LZ2XB";
                                elementUserID.value=userId;
                                elementUserID.setAttribute("type", "hidden");
                                form.appendChild(elementUserID); 

                                var elementSource = document.createElement("input"); 
                                elementSource.name="lead_source";
                                elementSource.value="EIGHT STAR STREET Official Website";
                                elementSource.setAttribute("type", "hidden");
                                form.appendChild(elementSource);

                                var lang = 'English';
                                if($('html').attr('lang') == 'zh-HK'){
                                    lang = 'Traditional Chinese';
                                }else if($('html').attr('lang') == 'zh-CN'){
                                    lang = 'Simplified Chinese';
                                }
                                var elementlLanguage = document.createElement("input"); 
                                elementlLanguage.name="00N0K00000LZ12s";
                                elementlLanguage.value=lang;
                                elementlLanguage.setAttribute("type", "hidden");
                                form.appendChild(elementlLanguage);

                                var elementlHidden = document.createElement("input"); 
                                elementlHidden.name="00N0K00000LZ2tq";
                                elementlHidden.value="1";
                                elementlHidden.setAttribute("type", "hidden");
                                form.appendChild(elementlHidden);

                                

                                var elementPICS = document.createElement("input"); 
                                elementPICS.name="00N0K00000LZ1zd";
                                elementPICS.value="1";
                                elementPICS.setAttribute("type", "hidden");
                                form.appendChild(elementPICS); 

                                var elementOptTime = document.createElement("input"); 
                                elementOptTime.name="00N0K00000LZ1zi";
                                elementOptTime.value=dayjs().format('YYYY-MM-DD HH:mm:ss');
                                elementOptTime.setAttribute("type", "hidden");
                                form.appendChild(elementOptTime); 

                                document.body.appendChild(form);

                                form.submit();

                                $form[0].reset();

                            }else if(!data['success']){
                                if(data['data'] == 'Sorry, that username already exists!'){
                                    $form.find('.response').text($form.find('.response').data('registered'));
                                }else{
                                    $form.find('.response').text($form.find('.response').data('error'));
                                }
                                
                            }
                            $form.find('button[type=submit]').removeClass('loading').removeAttr('disabled');
                        }
                    });
                }
                
            });
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Member.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Gallery = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-gallery',
        onEnter: function() {
            Gallery.$container = $(this.container);
            var script = Gallery.$container.find('main').data('script-src');
            Common.loadScript(script);
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Gallery.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Contact = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-contact',
        onEnter: function() {
            window.initMap = function() {

                var lat = 22.282236;
                var lng = 114.169007;

                var pointer_lat = 22.276314;
                var pointer_lng = 114.168092;
                Contact.point = new google.maps.LatLng(parseFloat(lat),parseFloat(lng));
                Contact.pin = new google.maps.LatLng(parseFloat(pointer_lat),parseFloat(pointer_lng));
                var style = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#212121"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#212121"
        },
        {
          "weight": 0.5
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8c8c8c"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.locality",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#908e8e"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "elementType": "labels.text",
      "stylers": [
        {
          "color": "#ac9570"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#ac9570"
        },
        {
          "weight": 0.5
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#313030"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#3a3632"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "color": "#3f3f40"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "stylers": [
        {
          "color": "#353537"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#181818"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#4a4440"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road",
      "stylers": [
        {
          "color": "#6b6761"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#5e5855"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#e4e1dc"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#373737"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#66615c"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3c3c3c"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#66615c"
        }
      ]
    },
    {
      "featureType": "road.highway.controlled_access",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#4e4e4e"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#2b2b2b"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3d3d3d"
        }
      ]
    }
  ];
              
                // if (window.matchMedia('(max-width: 1024px)').matches) {
                //     Contact.map = new google.maps.Map(Contact.$container.find('#google-map')[0], {
                //       center: Contact.point,
                //       scrollwheel: false,
                //       zoom: 16,
                //       styles: style
                //     });
                // }else{
                    
                // }
                Contact.map = new google.maps.Map(Contact.$container.find('#google-map')[0], {
                  center: Contact.point,
                  scrollwheel: false,
                  zoom: 15,
                  styles: style
                });
            }

            Common.loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBjZD9Ysiq5nqEFLFpsMi0i4eOVgckfB4s&callback=initMap&language=en").then(function(){

                  

                new google.maps.Marker({
                  position: Contact.pin,
                  map: Contact.map
                });
            });
        },
        onEnterCompleted: function() {
            Contact.$container = $(this.container);
            Common.pageTransitionEnter(Contact.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var BCLanding = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-connect-landing',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            BCLanding.$container = $(this.container);
            Common.pageTransitionEnter(BCLanding.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var EventListing = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-event-listing',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            EventListing.$container = $(this.container);
            Common.pageTransitionEnter(EventListing.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var EventDetail = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-event-detail',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            EventDetail.$container = $(this.container);
            Common.pageTransitionEnter(EventDetail.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var SalesSummary = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-sales-summary',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            SalesSummary.$container = $(this.container);
            Common.pageTransitionEnter(SalesSummary.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var SpecialOffer = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-special-offer',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            SpecialOffer.$container = $(this.container);
            Common.pageTransitionEnter(SpecialOffer.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var UnitInsight = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-unit-insight',
        onEnter: function() {
            UnitInsight.$container = $(this.container);
            UnitInsight.$container.find(".filter .button-wrapper button").on("click", function(){
                $(this).siblings("button").removeClass("active");
                $(this).addClass("active");
            });

            UnitInsight.$container.find('.filter button').on("click", function(){
                $(this).siblings("button").removeClass("active");
                $(this).addClass("active");
                UnitInsight.$container.find('.building img').removeClass('active');
                UnitInsight.$container.find('.building img[data-room="'+$(this).data('room')+'"]').addClass('active');
                UnitInsight.$container.find('.unit-option-wrapper .unit-option').removeClass('active');
                UnitInsight.$container.find('.unit-option-wrapper .unit-option[data-room="'+$(this).data('room')+'"]').addClass('active');

                if($(this).hasClass('overview-button')){
                  UnitInsight.$container.find('.main-wrapper').css({
                    display: 'none'
                  });
                  UnitInsight.$container.find('.overview-wrapper').css({
                    display: 'block'
                  });
                }else{
                  UnitInsight.$container.find('.overview-wrapper').css({
                    display: 'none'
                  });
                  UnitInsight.$container.find('.main-wrapper').attr('style', 'display: -ms-flex; display: flex');
                }
            });

            UnitInsight.$container.find('.unit-option .buttons button').on("click", function(){
                var src = $(this).data('src');
                var src2 = $(this).data('src2');
                var $popup = $("<div class='interactive-popup'><div class='wrapper'><button type='button' class='close'></button><img src='"+src+"'/></div></div>");
                $popup.appendTo(UnitInsight.$container.find('.plans-popup-wrapper'));
                $popup.css({
                    "z-index": 2
                });
                if(src2){
                  $popup.css({
                      "z-index": 3,
                      left: 50
                  });
                }
                $popup.scale = 1;
                interact($popup[0]).draggable({
                    listeners: { move: dragMoveListener }
                  }).gesturable({
                    listeners: {
                      start (event) {
                        
                      },
                      move (event) {
                        dragMoveListener(event, $popup)
                      },
                      end (event) {
                        $popup.scale = $popup.scale * event.scale
                      }
                    }
                  })
                if(src2){
                  var $popup2 = $("<div class='interactive-popup'><div class='wrapper'><button type='button' class='close'></button><img src='"+src2+"'/></div></div>");
                  $popup2.appendTo($('.plans-popup-wrapper'));
                  $popup2.css({
                      "z-index": 2,
                      right: 50,
                  });
                  $popup2.scale = 1;
                    interact($popup2[0])
                      .draggable({
                          listeners: { move: dragMoveListener }
                        })
                      .gesturable({
                          listeners: {
                            start (event) {
                              
                            },
                            move (event) {
                              dragMoveListener(event, $popup2)
                            },
                            end (event) {
                              $popup2.scale = $popup2.scale * event.scale
                            }
                          }
                        })
                }
            });

            $(document).on("mousedown touchstart", ".interactive-popup", function(){
                UnitInsight.$container.find(".interactive-popup").siblings().css({
                    "z-index": 1
                });
                $(this).css({
                    "z-index": 2
                });
            });

            $(document).on("click", ".interactive-popup .close", function(){
                $(this).closest('.interactive-popup').remove();
            });


            function dragMoveListener (event, $ele) {
              var target = event.target;
              var currentScale;
              if($ele){
                currentScale = event.scale * $ele.scale
            }else{
                currentScale = parseFloat(target.getAttribute('data-scale')) || 1;
            }

              var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
              var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
              var scale = currentScale

              target.style.webkitTransform =
                target.style.transform =
                  'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ')'

              target.setAttribute('data-x', x)
              target.setAttribute('data-y', y)
              target.setAttribute('data-scale', scale)
            }

            // this function is used later in the resizing and gesture demos
            window.dragMoveListener = dragMoveListener
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(UnitInsight.$container).then(function(){
                new Swiper (UnitInsight.$container.find('.text .swiper-container')[0], {
                    slidesPerView: 1,
                    simulateTouch: false,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    autoplay: {
                        delay: 3000,
                    },
                    speed: 2000
                });
            });
        },
        onLeaveCompleted: function() {
        }
    })
}

var Dummy = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'dummy',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Dummy.$container = $(this.container);
            Common.pageTransitionEnter(Dummy.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var P404 = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'http404',
        onEnter: function() {
            Common.pageTransitionEnter();
        },
        onEnterCompleted: function() {
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Polyfill = {
    init: function(){
        if (!Array.prototype.find) {
            Array.prototype.find = function(predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            };
        }
    }
}

$(function(){
    Polyfill.init();

    Home.init();

    Location.init();
    Living.init();
    Design.init();
    Gallery.init();
    
    BCLanding.init();


    Contact.init();
    Terms.init();
    Documents.init();
    Member.init();
    
    EventListing.init();
    EventDetail.init();
    SalesSummary.init();
    SpecialOffer.init();
    UnitInsight.init();

    Common.init();
    P404.init();
    Barba.Pjax.init();
});


class ScrollablePopup {
    constructor() {
        this.top = 0;
        this.$parent = null;
        this.$content = null;
        this.markup = "<div class='scrollable-popup'><div class='overlay close'></div><div class='content'></div></div>";
        this.$popup = null;
        this.eventQueue = {};
        Common.popupInstances.push(this);
    }

    open($element, popupClass){
        var _this = this;
        _this.$parent = $element.parent();
        _this.$content = $element;
        _this.$contener = Common.popupInstances.length > 1 ? Common.popupInstances[Common.popupInstances.length - 2].$popup : $element.closest('.transition-container');
        if(Common.sidebarInstances.length > 0) _this.$contener = Common.sidebarInstances[Common.sidebarInstances.length - 1].$sidebar;
        _this.top = $(document).scrollTop();
        _this.$contener.css({
            position: "fixed",
            top: -_this.top,
            overflow: "hidden"
        });
        // $(".sticky").css({
        //  position: "fixed",
        //  top: 0
        // });
        _this.$popup = $(_this.markup).clone();
        _this.$popup.addClass(popupClass);
        _this.$popup.find('.content').append($element);

        $("body").append(_this.$popup);
        $(document).scrollTop(0);

        anime.timeline({
            easing: 'easeOutCubic'
        }).add({
            targets: _this.$popup[0],
            opacity: [0,1],
            duration: 200
        }).add({
            targets: _this.$popup.find('.content')[0],
            opacity: [0,1],
            translateY: [40, 0],
            duration: 500
        });
        _this.$popup.addClass('active');

        _this.$popup.find('.close').on('click touch',function(){
            _this.close();
        });
    }

    close(goTop){
        if($(".scrollable-popup").length){
            var _this = this;
            var top = goTop ? 0 : this.top;
            anime({
                targets: this.$popup[0],
                opacity: 0,
                easing: 'easeOutCubic',
                duration: 200,
                complete: function(){
                    _this.$parent.append(_this.$content);
                    _this.$popup.remove();
                    _this.$contener.css({
                        position: "relative",
                        top: "auto",
                        overflow: ""
                    });
                    // $(".sticky").css({
                    //  position: "sticky",
                    //  top: "auto"
                    // });
                    $(document).scrollTop(top);
                    _this.destroy();

                    if(!$('html').hasClass('ie')) _this.trigger('close');

                    if(_this.eventQueue['close']) _this.eventQueue['close'] = [];
                }
            });
        }
    }

    once(event, callback){
        if(!this.eventQueue[event])
            this.eventQueue[event] = [];
        this.eventQueue[event].push(callback);
    }

    trigger(event, params){
        if(this.eventQueue[event]) {
            for(var i in this.eventQueue[event])
                this.eventQueue[event][i](params);
        }
    }

    destroy(){
        var i = Common.popupInstances.indexOf(this);
        Common.popupInstances.splice(i, 1);
        delete this;
    }
}

var SwiperCustom = {
    progress(swiper, progress) {

    },
    setTransition(swiper, transitionSpeed) {
        
    },
    setTranslate(swiper, wrapperTranslate) {
        // const durationInSeconds = this.getTransitionSpeed() / 1000;
        const slides = Object.values(swiper.slides).slice(0, -1);
        // const originIndex = Creation.getActiveIndexBeforeTransitionStart(
        //   swiper,
        //   slides
        // );
        const originIndex = swiper.activeIndex;
        var newIndex = 0;
        const isDragging = !Math.abs(slides[swiper.activeIndex].progress%1 === 0);
        if(isDragging){
            newIndex = originIndex;
        }else{
            const step = slides[swiper.activeIndex].progress;
            newIndex = originIndex + step;
        }
        if($(slides[newIndex]).hasClass('dark')){
            $('html').addClass('dark-section');
        }else{
            $('html').removeClass('dark-section');
        }

        if($(slides[newIndex]).hasClass('mobile-light')){
            $('html').addClass('mobile-light-section');
        }else{
            $('html').removeClass('mobile-light-section');
        }

        if(originIndex !== newIndex){
            $(slides).each(function(){
                $(this).removeClass('from-below to-below from-above to-above');
            });

            if($(slides[newIndex]).find('.text-col').length){
                $(slides[newIndex]).find('.text-col')[0].scrollTop = 0;
            }

            if(originIndex > newIndex){
                $(slides[newIndex]).addClass('from-below');
                $(slides[originIndex]).addClass('to-above');
            }else{
                $(slides[newIndex]).addClass('from-above');
                $(slides[originIndex]).addClass('to-below');
            }

            // play and stop video
            if($(slides[newIndex]).find('.video-bkg video').length){
                var video = $(slides[newIndex]).find('.video-bkg video')[0];
                video.currentTime = 0;
                video.play();
            }
            if($(slides[originIndex]).find('.video-bkg video').length){
                $(slides[originIndex]).find('.video-bkg video')[0].pause();
            }

            setTimeout(function(){
                swiper.animating = false;
            }, 600);

            $(slides[newIndex]).find('.lazyload').each(function(){
                $(this).show();
            });
            
        }

        

        // console.log(originIndex);
        // var newIndex = 0;
        // if(swiper.swipeDirection === 'next') newIndex = originIndex + 1;
        // else if(swiper.swipeDirection === 'prev') newIndex = originIndex - 1;

        // const animationProgress = slides[originIndex].progress;console.log(animationProgress);
        // const newIndex = originIndex + Creation.getDirection(animationProgress);
        // console.log(newIndex,originIndex);
// console.log(originIndex);
        slides.map((slide, index) => {
            if(originIndex < 0) return;
            if(originIndex > newIndex){
                if($(slides[newIndex]).data('animation-next') === 'fade'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "pointer-events": "all",
                            "z-index": slides.length + 2
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "opacity": 0,
                            "pointer-events": "all",
                            "z-index": slides.length - index
                        });
                    }
                }else if($(slides[newIndex]).data('animation-next') === 'mask'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "-webkit-clip-path": "inset(0 0 0 0)",
                            "clip-path": "inset(0px 0px 0px 0px)",
                            "pointer-events": "all",
                            "z-index": slides.length + 2
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "-webkit-clip-path": "inset(0 0 100% 0)",
                            "clip-path": "inset(0 0 100% 0)",
                            "pointer-events": "none",
                            "z-index": slides.length - index
                        });
                    }
                }
            }else{
                if($(slides[newIndex]).data('animation-prev') === 'fade'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "pointer-events": "all",
                            "z-index": slides.length + 1
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "opacity": 0,
                            "pointer-events": "all",
                            "z-index": slides.length - index
                        });
                    }
                }else if($(slides[newIndex]).data('animation-prev') === 'mask'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "-webkit-clip-path": "inset(0 0 0 0)",
                            "clip-path": "inset(0px 0px 0px 0px)",
                            "pointer-events": "all",
                            "z-index": slides.length + 1
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "-webkit-clip-path": "inset(0 0 100% 0)",
                            "clip-path": "inset(0 0 100% 0)",
                            "pointer-events": "none",
                            "z-index": slides.length - index
                        });
                    }
                }
            }

          // const offset = slide.swiperSlideOffset;
          // let x = -offset;
          // if (!swiper.params.virtualTranslate) x -= swiper.translate;
          // let y = 0;
          // if (!swiper.isHorizontal()) {
          //   y = x;
          //   x = 0;
          // }
          // TweenMax.set(slide, {
          //   x,
          //   y
          // });

          // const clip = (val, min, max) => Math.max(min, Math.min(val, max));
          // const ZOOM_FACTOR = 0.05;

          // const opacity = Math.max(1 - Math.abs(slide.progress), 0);

          // const clippedProgress = clip(slide.progress, -1, 1);
          // const scale = 1 - ZOOM_FACTOR * clippedProgress;

          // TweenMax.to(slide, durationInSeconds, {
          //   scale,
          //   opacity
          // });
        });
    },
    getActiveIndexBeforeTransitionStart(swiper, slides) {
        const isDragging = !Math.abs(slides[swiper.activeIndex].progress === 1);
        if (isDragging) {
            return swiper.slidesGrid.indexOf(
                -swiper.touchEventsData.startTranslate || swiper.params.initialSlide
            );
        } else {
            return swiper.activeIndex;
        }
    },
    getDirection(animationProgress) {
        if (animationProgress === 0) {
            return 0;
        } else if (animationProgress > 0) {
            return 1;
        } else  if (animationProgress < 0){
            return -1;
        }else{
            return 0;
        }
    }
}

var swiperMainOption = function($this, scrollbar){
    return {
        // effect: 'mask',
        speed: 1000,
        watchSlidesVisibility: true,
        virtualTranslate: true,
        watchSlidesProgress: true,
        touchStartPreventDefault: false,
        // longSwipesRatio: 0,
        // simulateTouch: false,
        mousewheel: {
            // invert: true,
        },
        direction: 'vertical',
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: $(this).siblings('.slider>.swiper-button-next'),
            prevEl: $(this).siblings('.slider>.swiper-button-prev'),
        },
        scrollbar: scrollbar,
        pagination: {
              el: $this.find('.swiper-pagination.nav')[0],
              clickable: true
        },
        // on: {
        //     init: function(){
        //         var swiper = this;
        //         var slides = $(swiper.slides);
        //         slides = slides.filter(function() {
        //             return $(this).is(":visible");
        //         });

        //         for (var i = 0; i < slides.length; i += 1) {
        //           var $slideEl = slides.eq(i);
        //           var offset = swiper.height * i;
        //           var tx = -offset;
        //           if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        //           var ty = 0;
        //           if (!swiper.isHorizontal()) {
        //             ty = tx;
        //             tx = 0;
        //           }
        //           var slideOpacity = swiper.params.fadeEffect.crossFade
        //             ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
        //             : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        //           $slideEl.css({
        //             "z-index": slides.length - i,
        //           });

        //           // $slideEl.height(offset);
        //           $slideEl.css({
        //             transform: "translate3d(" + tx + "px, " + ty + "px, 0px)"
        //           });

        //           if(i === 0){
        //             $slideEl.addClass("from-above");

        //             if($slideEl.hasClass('dark')){
        //                 $('html').addClass('dark-section');
        //             }else{
        //                 $('html').removeClass('dark-section');
        //             }

        //             if($slideEl.hasClass('mobile-light')){
        //                 $('html').addClass('mobile-light-section');
        //             }else{
        //                 $('html').removeClass('mobile-light-section');
        //             }

        //             if($slideEl.find('.video-bkg video').length) $slideEl.find('.video-bkg video')[0].play();
        //           }

        //           // $slideEl.css({
        //           //   transition: "all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s"
        //           // });
        //         }

        //         setTimeout(function(){
        //             Common.$container.find('.section.swiper-slide').css({
        //                 transition: "all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s"
        //             });
        //         }, 600);

        //         setTimeout(function(){
        //             swiper.update();
        //             for (var i = 0; i < slides.length; i += 1) {
        //               var $slideEl = slides.eq(i);
        //               var offset = swiper.height * i;
        //               var tx = -offset;
        //               if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        //               var ty = 0;
        //               if (!swiper.isHorizontal()) {
        //                 ty = tx;
        //                 tx = 0;
        //               }
        //               $slideEl.css({
        //                 transform: "translate3d(" + tx + "px, " + ty + "px, 0px)"
        //               });
        //             }
        //         }, 100);

        //         Common.$container.find('.section-anchor').on('click', function(){
        //             var target = $(this).data('target');
        //             swiper.slideTo(target, 0, false);
        //         });

        //         enableTouchSwipe();
        //         // $(window).on('mousewheel', function(e){
        //         //     console.log(e);
        //         // });
        //     },
        //     resize: function(){
        //         var swiper = this;
        //         var slides = $(swiper.slides);
        //         slides = slides.filter(function() {
        //             return $(this).is(":visible");
        //         });
        //         for (var i = 0; i < slides.length; i += 1) {
        //           var $slideEl = slides.eq(i);
        //           var offset = swiper.height * i;
        //           var tx = -offset;
        //           if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        //           var ty = 0;
        //           if (!swiper.isHorizontal()) {
        //             ty = tx;
        //             tx = 0;
        //           }
        //           var slideOpacity = swiper.params.fadeEffect.crossFade
        //             ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
        //             : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        //             swiper.update();
        //             $slideEl.css({
        //                 transform: "translate3d(" + tx + "px, " + ty + "px, 0px)"
        //             });
                    
                  
        //         }
                
        //         // swiper.updateSlidesOffset();
        //         // swiper.update();
        //         // window.location.reload(false); 
                
        //     },
        //     progress(progress) {
        //         const swiper = this;
        //         if (swiper.params.effect !== "mask") return;
        //         SwiperCustom.progress(swiper, progress);
        //     },
        //     setTransition(speed) {
        //         const swiper = this;
        //         if (swiper.params.effect !== "mask") return;
        //         SwiperCustom.setTransition(swiper, speed);
        //     },
        //     setTranslate(translate) {
        //         const swiper = this;
        //         if (swiper.params.effect !== "mask") return;
        //         SwiperCustom.setTranslate(swiper, translate);
        //     },
        //     // touchStart(e){
        //     //     if($(e.target).closest('.scrollable').length){
        //     //         e.preventDefault();
        //     //     }else{

        //     //     }
        //     // },
        //     // touchEnd(){
                
        //     // },
        // }
    }
};

var swiperIeEvent = function(){
    const swiper = this;
    const slides = swiper.slides;
    Common.newIndex = swiper.activeIndex;

    if($(slides[Common.newIndex]).hasClass('dark')){
        $('html').addClass('dark-section');
    }else{
        $('html').removeClass('dark-section');
    }

    if(Common.originIndex > Common.newIndex){
        $(slides[Common.newIndex]).addClass('from-below');
        $(slides[Common.originIndex]).addClass('to-above');
    }else{
        $(slides[Common.newIndex]).addClass('from-above');
        $(slides[Common.originIndex]).addClass('to-below');
    }

    // play and stop video
    if($(slides[Common.newIndex]).find('.video-bkg video').length){
        var video = $(slides[Common.newIndex]).find('.video-bkg video')[0];
        video.currentTime = 0;
        video.play();
    }
    if($(slides[Common.originIndex]).find('.video-bkg video').length){
        $(slides[Common.originIndex]).find('.video-bkg video')[0].pause();
    }

    $(slides).each(function(index, slide){
        if(Common.originIndex < 0) return;
        if(index === Common.newIndex){
            $(slide).css({
                "z-index": $(slides).length + 1
            });
        }else{
            $(slide).css({
                "z-index": $(slides).length - index
            });
        }
    });

    Common.originIndex = Common.newIndex;
}

var enableTouchSwipe = function(){
    Common.touchStart = 0;
    Common.touchEnd = 0;
    Common.scrollPos = 0;
    Common.startPos = '';
    Common.sliding = false;
    Common.startTime = 0;
    Common.endTime = 0;

    $('body')[0].addEventListener("touchstart",function(e){
        var index = Common.sectionSlider.activeIndex;
        var $activeSection = Common.$container.find('.section').eq(index).find('.text-col');
        Common.touchStart = e.touches[0].clientY;
        Common.scrollPos = $activeSection.scrollTop();
        const isBottom = $activeSection.length && $activeSection[0].scrollHeight - $activeSection[0].scrollTop === $activeSection[0].clientHeight;
        const isBelowBottom = $activeSection.length && $activeSection[0].scrollHeight - $activeSection[0].scrollTop < $activeSection[0].clientHeight;
        const isTop = $activeSection.length && $activeSection[0].scrollTop === 0;
        const isAboveTop = $activeSection.length && $activeSection[0].scrollTop < 0;

        if (isBottom && isTop) {
            Common.startPos = 'all';
        }else if (isBottom) {
            Common.startPos = 'bottom';
        }else if (isTop) {
            Common.startPos = 'up';
        }else if (isBelowBottom) {
            Common.startPos = 'below';
        }else if (isAboveTop) {
            Common.startPos = 'above';
        }else{
            Common.startPos = '';
        }

        Common.touchStart = e.touches[0].clientY;
        Common.scrollPos = $activeSection.scrollTop();
        Common.startTime = + new Date();
    }, {passive: false });

    $('body')[0].addEventListener("touchmove",function(e){
        // e.preventDefault();
        Common.touchEnd = e.touches[0].clientY;
        var index = Common.sectionSlider.activeIndex;
        var $activeSection = Common.$container.find('.section').eq(index).find('.text-col');

        // next section if touchstart at bottom and move distance more than 30px

        if ((Common.startPos === 'all' || Common.startPos === 'bottom') && !Common.sliding && Common.touchEnd - Common.touchStart <= -20) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slideNext();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }else if ((Common.startPos === 'all' || Common.startPos === 'up') && !Common.sliding && Common.touchEnd - Common.touchStart >= 20) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slidePrev();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }if ( Common.startPos === 'below' && !Common.sliding && Common.touchEnd - Common.touchStart <= -100) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slideNext();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }else if (Common.startPos === 'above' && !Common.sliding && Common.touchEnd - Common.touchStart >= 100) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slidePrev();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }else if(!Common.sliding){
            // $activeSection[0].scrollTop = Common.scrollPos - Common.touchEnd + Common.touchStart;
            Common.endTime = + new Date();
        }
    }, {passive: false });

    $('body')[0].addEventListener("touchend",function(e){
        if(!Common.sliding){
            var index = Common.sectionSlider.activeIndex;
            var $activeSection = Common.$container.find('.section').eq(index).find('.text-col');
            if($activeSection.length) Common.scrollPos = $activeSection[0].scrollTop;
            // var time = Common.endTime - Common.startTime;
            // anime({
            //     targets: $activeSection[0],
            //     scrollTop: Common.scrollPos + 1/(time / 100)* (- Common.touchEnd + Common.touchStart),
            //     duration: 300,
            //     easing: 'easeOutQuad'
            // });
        }
    }, {passive: false });
}
